import * as React from 'react'

import { CmsContainerPage, CmsHeadTags, CmsPageLayout } from '@grandvision/bloomreach'
import { Container } from '@grandvision/elements'
import { ErrorPage } from '@grandvision/layout'

import { defaultErrorProps } from '../components/error-props'
import { layoutProps } from '../components/layout-props'

type InitialProps = {
  locale: string
  statusCode: number
}

type Props = InitialProps & {}

const Error = ({ locale, statusCode }: Props) => {
  const ErrorContent = (
    <React.Fragment>
      <CmsHeadTags title={defaultErrorProps[locale].header} noIndex={true} noFollow={true} />
      <Container className="error-layout">
        <ErrorPage {...defaultErrorProps[locale]} />
      </Container>
    </React.Fragment>
  )

  // We only receive a pageModel on 200 and 404 responses
  if (statusCode === 404) {
    return (
      <CmsContainerPage>
        <CmsPageLayout {...layoutProps}>{ErrorContent}</CmsPageLayout>
      </CmsContainerPage>
    )
  }

  return ErrorContent
}

Error.getInitialProps = ({ req, res, err }): InitialProps => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 500
  const locale = req?.locale.toString() ?? 'es-ES'
  return { locale, statusCode }
}

export default Error
